// extracted by mini-css-extract-plugin
module.exports = {"container":"mvWdu8OoeQ1tcf_k8F8Az"};